import { render, staticRenderFns } from "./searchArea.vue?vue&type=template&id=1aacae00&scoped=true"
import script from "./searchArea.vue?vue&type=script&lang=js"
export * from "./searchArea.vue?vue&type=script&lang=js"
import style0 from "./searchArea.vue?vue&type=style&index=0&id=1aacae00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aacae00",
  null
  
)

export default component.exports